module.exports = __webpack_public_path__ + "img/027.3e8c5b9c.png";